// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading{
    position: fixed;
    z-index: 99999;
    height: 100%;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.2);
    display: none;
}
.spinner {
    margin: 15% 45%;
    width: 50px;
    height: 40px;
    text-align: center;
    font-size: 10px;
    position: absolute;
    z-index:99;
}
.spinner > div {
    background-color: var(--color-primary-orange);;
    height: 100%;
    width: 6px;
    display: inline-block;
    animation: sk-stretchdelay 1.2s infinite ease-in-out;
}
.spinner .rect2 {
    animation-delay: -1.1s;
}
.spinner .rect3 {
    animation-delay: -1.0s;
}
.spinner .rect4 {
    animation-delay: -0.9s;
}
.spinner .rect5 {
    animation-delay: -0.8s;
}
@keyframes sk-stretchdelay {
    0%, 40%, 100% { 
        transform: scaleY(0.4);
        -webkit-transform: scaleY(0.4);
    }  20% { 
        transform: scaleY(1.0);
        -webkit-transform: scaleY(1.0);
    }
}`, "",{"version":3,"sources":["webpack://./src/shared/components/Loader.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,cAAc;IACd,YAAY;IACZ,WAAW;IACX,0CAA0C;IAC1C,aAAa;AACjB;AACA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,6CAA6C;IAC7C,YAAY;IACZ,UAAU;IACV,qBAAqB;IAGrB,oDAAoD;AACxD;AACA;IAEI,sBAAsB;AAC1B;AACA;IAEI,sBAAsB;AAC1B;AACA;IAEI,sBAAsB;AAC1B;AACA;IAEI,sBAAsB;AAC1B;AAKA;IACI;QACI,sBAAsB;QACtB,8BAA8B;IAClC,GAAG;QACC,sBAAsB;QACtB,8BAA8B;IAClC;AACJ","sourcesContent":[".loading{\r\n    position: fixed;\r\n    z-index: 99999;\r\n    height: 100%;\r\n    width: 100%;\r\n    background-color: rgba(255, 255, 255, 0.2);\r\n    display: none;\r\n}\r\n.spinner {\r\n    margin: 15% 45%;\r\n    width: 50px;\r\n    height: 40px;\r\n    text-align: center;\r\n    font-size: 10px;\r\n    position: absolute;\r\n    z-index:99;\r\n}\r\n.spinner > div {\r\n    background-color: var(--color-primary-orange);;\r\n    height: 100%;\r\n    width: 6px;\r\n    display: inline-block;\r\n\r\n    -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;\r\n    animation: sk-stretchdelay 1.2s infinite ease-in-out;\r\n}\r\n.spinner .rect2 {\r\n    -webkit-animation-delay: -1.1s;\r\n    animation-delay: -1.1s;\r\n}\r\n.spinner .rect3 {\r\n    -webkit-animation-delay: -1.0s;\r\n    animation-delay: -1.0s;\r\n}\r\n.spinner .rect4 {\r\n    -webkit-animation-delay: -0.9s;\r\n    animation-delay: -0.9s;\r\n}\r\n.spinner .rect5 {\r\n    -webkit-animation-delay: -0.8s;\r\n    animation-delay: -0.8s;\r\n}\r\n@-webkit-keyframes sk-stretchdelay {\r\n    0%, 40%, 100% { -webkit-transform: scaleY(0.4) }  \r\n    20% { -webkit-transform: scaleY(1.0) }\r\n}\r\n@keyframes sk-stretchdelay {\r\n    0%, 40%, 100% { \r\n        transform: scaleY(0.4);\r\n        -webkit-transform: scaleY(0.4);\r\n    }  20% { \r\n        transform: scaleY(1.0);\r\n        -webkit-transform: scaleY(1.0);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
